export default __webpack_public_path__ + "static/media/PAFI_Minutes Summary of GMS of June 30, 2025.7e16994b.pdf";